module.exports = __webpack_public_path__ + "70114ed4d78ae6a397e5ed2e9a513a30.png";


//////////////////
// WEBPACK FOOTER
// ./work/animalz/img/left.png
// module id = 597
// module chunks = 0